<template>
  <div class="card my-2 mx-2">
    <div class="pt-4 pb-3 text-center card-header">
      <span class="text-uppercase font-weight-bold text-dark overflow-text">
        {{ empresa.razaoSocial }}
      </span>
      <p class="mb-0 text-sm text-muted overflow-text">
        <small>
          {{ empresa.nomeFantasia || 'Sem nome fantasia' }}
        </small>
      </p>
    </div>
    <div class="pt-0 text-center card-body">
      <div class="d-flex justify-content-between">
        <label>CNPJ</label>
        <h6 class="mb-0 font-weight-bolder">
          {{ empresa.documento }}
        </h6>
      </div>
      <hr class="mt-2 horizontal dark">
      <div class="d-flex justify-content-between">
        <label>Código Unidade</label>
        <h6 class="mb-0 font-weight-bolder">
          {{ empresa.conexaUnidadeId }}
        </h6>
      </div>
      <hr class="mt-2 mb-4 horizontal dark">
      <router-link 
        :to="{ name: 'Empresa', params: { id: empresa.id } }" 
        class="mt-3 mb-0 btn btn-md btn-icon d-lg-block bg-dark text-white">
        Editar
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmpresaCard",
  props: {
    empresa: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  methods: {
    getUnidadeNome(id) {
      const unidades = {
        3: 'BITZ',
        4: 'BS'
      };
      return unidades[id] || 'Desconhecida';
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.4px solid #212529;

  .overflow-text {
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
